import HomeActionTypes from "./home.types";

export const homeSyncStart = (payload) => ({
  type: HomeActionTypes.HOME_SYNC_START,
  payload,
});

export const homeSyncFinish = (payload) => ({
  type: HomeActionTypes.HOME_SYNC_FINISH,
  payload,
});

export const thingSyncStart = (payload) => ({
  type: HomeActionTypes.THING_SYNC_START,
  payload,
});

export const thingSyncFinish = (payload) => ({
  type: HomeActionTypes.THING_SYNC_FINISH,
  payload,
});

export const resetThings = (payload) => ({
  type: HomeActionTypes.RESET_THINGS,
  payload,
});

export const favoriteSyncStart = (payload) => ({
  type: HomeActionTypes.FAVORITE_SYNC_START,
  payload,
});

export const favoriteSyncFinish = (payload) => ({
  type: HomeActionTypes.FAVORITE_SYNC_FINISH,
  payload,
});

export const resetFavorites = (payload) => ({
  type: HomeActionTypes.RESET_FAVORITES,
  payload,
});

export const updateHomeSlideId = (payload) => ({
  type: HomeActionTypes.UPDATE_HOME_SLIDE_ID,
  payload,
});

export const updateBannerFavorite = (payload) => ({
  type: HomeActionTypes.UPDATE_BANNER_FAVORITE,
  payload,
});

export const updateBannerShare = (payload) => ({
  type: HomeActionTypes.UPDATE_BANNER_SHARE,
  payload,
});

export const updateBannerComment = (payload) => ({
  type: HomeActionTypes.UPDATE_BANNER_COMMENT,
  payload,
});

export const setEmployeeData = (payload) => ({
  type: HomeActionTypes.SET_EMPLOYEE_DATA,
  payload,
});

export const updateShowRegisterOverlayFlag = (payload) => ({
  type: HomeActionTypes.UPDATE_SHOW_REGISTER_OVERLAY_FLAG,
  payload,
});

export const updateShowSigninOverlayFlag = (payload) => ({
  type: HomeActionTypes.UPDATE_SHOW_SIGNIN_OVERLAY_FLAG,
  payload,
});

export const updateShowAccountOverlayFlag = (payload) => ({
  type: HomeActionTypes.UPDATE_SHOW_ACCOUNT_OVERLAY_FLAG,
  payload,
});

export const updateShowResetPasswordOverlayFlag = (payload) => ({
  type: HomeActionTypes.UPDATE_SHOW_RESET_PASSWORD_OVERLAY_FLAG,
  payload,
});
